
import xhr from './../../../utils/xhr';


const api = {
    get: (filters = {language: null, entityId: null, riskLevel: null, riskAngle: null}, sorting = {
        sortBy: "_id",
        direction: "DESC"
    }, pagination = {pageSize: -1, pageNumber: -1}) => {
        let searchFilter = (filters.language !== null ? `&language=${filters.language}` : "") +
            (filters.riskLevel !== null ? `&riskLevel=${filters.riskLevel}` : "") +
            (filters.riskAngle !== null ? `&riskAngle=${filters.riskAngle}` : "");
        return xhr.get({
            url: `/api/entities/preview/${filters.entityId}/?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    count: (filters = {language: null, feedId: null}) => {
        let searchFilter = (filters.language !== null ? `&language=${filters.language}` : "") +
            (filters.riskLevel !== null ? `&riskLevel=${filters.riskLevel}` : "") +
            (filters.riskAngle !== null ? `&riskAngle=${filters.riskAngle}` : "");
        return xhr.get({
            url: `/api/feeds/${filters.feedId}/articles/count/${searchFilter}`
        });
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/components/PreviewCompany.api.js